module.exports = __webpack_public_path__ + "img/icon-money-2.5a59ec2a.svg";